<template>
  <div class="online-training">
    <!-- <p class="title">{{$t('driver_onboarding.training.step')}}</p> -->
    <section class="featured-courses" v-if="!loading">
        <h3>Bài học nổi bật</h3>
				

				<div class="is-flex has-scroll-horizontal" style=" overflow: auto;">
					<div v-for="(item, index) in featuredCourses" :key="index" class="card" @click="redirectPage(item.slug)" style="margin-right: 1rem">
						<div class="card-image">
								<div class="image is16by9">
									<a @click="info(item._id)" v-lazy-container="{selector : 'img', 'loading' : '/img/loading.gif'}">
										<img :data-src="item.image">
									</a>
								</div>
								<div v-if="item.score" class="score-badge is-flex" :class="!item.is_passed ? 'uncompleted' : 'completed'">
									<div class="score">
										Điểm : {{item.score ? Math.floor(item.score/10) : 0}} / 10
									</div>
									<div class="status">
										{{item.is_passed ? 'Đã hoàn thành' : 'Chưa hoàn thành'}}
									</div>
								</div>
								<div class="score-badge is-flex" v-else>
									<div class="score">
										Điểm : 0 / 10
									</div>
									<div class="status">
										Chưa tham gia
									</div>
								</div>
						</div>
						<div class="card-content">
							<div class="content">
									<p class="title is-6">{{ item.title }}</p>
									<p class="subtitle is-7">{{item.description}}</p>
							</div>
						</div>
						<div class="card-action">
							<b-button :class="{'redo' : item.is_passed}">
								{{!item.score ? 'Tham gia ngay' : (item.is_passed ? 'Ôn tập lại' : 'Làm lại bài')}}
							</b-button>
						</div>
					</div>
				</div>
			
    </section>

    <section class="regular-courses">
			<div v-for="course in normalCourses" :key="course._id">
				<p class="title-category">{{course.category.name}}</p>
				<p class="desc-category">{{course.category.description}}</p>
				<div class="courses">
					<NormalCourses 
						v-if="!loading" 
						:courses="course.courses"
						:expand="expandedCourses.includes(course._id)"
						:limit="limitItems"
					/>
					<div class="has-text-centered" v-if="course.courses.length > limitItems && !expandedCourses.includes(course._id)">
						<b-button class="btn-action" @click="seeMore(course._id)">Xem thêm</b-button>
					</div>
				</div>
			</div>
    </section>

     <b-loading :is-full-page="loading" :active.sync="loading" :can-cancel="true"></b-loading>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NormalCourses from "./NormalCourses";


export default {
  components: {
		NormalCourses
  },
  computed: {
    ...mapGetters(["supplierToken", "courses", 'supplierProfile']),
    mobileViewWidth(){
      return screen.width
    },
    perList() {
        return screen.width <= 768 ? 1.5 : (this.featuredCourses.length > 3 ? 3 : this.featuredCourses.length)
    }
  },
  data() {
    return {
        loading: false,
        // arrow: screen.width > 768 ? true : false,
        // arrowHover: true,
        // drag: screen.width > 768 ? true : false,
        // values: 0,
				limitItems : 3,
				featuredCourses: [],
				normalCourses : [],
				expandedCourses: [],
				// iconPack: 'mdi',
				// iconPrev: 'arrow-left',
				// iconNext: 'arrow-right',
				
    };
  },
  methods: {
		info(value) {
				this.values = value
		},
		filterData() {
				this.featuredCourses = this.courses.filter(e => e._id === this.$constants.CATEGORIES.FEATURED)
				this.normalCourses = this.courses.filter(e => e._id !== this.$constants.CATEGORIES.FEATURED)

				if(this.featuredCourses && this.featuredCourses.length !== 0) {
						this.featuredCourses = this.featuredCourses[0] && this.featuredCourses[0].courses

						if(this.featuredCourses.length < 3) {
								this.perList = this.featuredCourses.length
						}
				}

				const exam = this.supplierProfile && this.supplierProfile.extra && this.supplierProfile.extra.exam

				if (exam && exam.length > 0) {
					this.featuredCourses.forEach(course => {
						course.score = 0
						exam.forEach(e => {
							if (e.course_id === course._id) {
								course.score = e.score > course.score  ? e.score : course.score
							}
						})
						
						course.is_passed = course.score >= course.passing_score
					})
				}

				this.normalCourses.sort((a, b) =>  a.category.sort - b.category.sort)
				this.featuredCourses.sort((a, b) => a.sort - b.sort)

		},
		seeMore(courseId) {
			this.expandedCourses.push(courseId)
		},
		redirectPage(slug) {
			this.$router.push({name : 'course', params : {slug : slug}})
		}
  },
  mounted() {
    if (!this.courses || this.courses.length === 0) {
        this.loading = true
        this.$store.dispatch("getAllCourses", this.supplierToken)
        .finally(() => {
          this.loading = false     
          this.filterData()     
        })
    } else {
        this.filterData()     
    }
  }
};
</script>
<style lang="scss">
.online-training {
  .featured-courses {
        position: relative;
        background-image: url('/img/onboard-driver/featured-courses.png');
        background-repeat: no-repeat;
        background-position: center center;
        // background-attachment: fixed;
        background-size: cover;
        padding: 2rem;

        h3 {
            color: #fff;
						font-weight: 500;
						font-size: 30px;
						margin-bottom: 1rem;
        }

				.featured {
					// max-width: 85%;
				}

        .has-scroll-horizontal {
            overflow-x: auto;
            overflow-y: hidden;
            padding-bottom: 1rem;

            &::-webkit-scrollbar-track {
                background-color: #ebebeb;
                -webkit-border-radius: 10px;
                border-radius: 10px;
            }


            &::-webkit-scrollbar {
                height: 3px;
            }
            

            &::-webkit-scrollbar-thumb {
                -webkit-border-radius: 10px;
                border-radius: 10px;
                background: #ff8200; 
            }
           
        }

				.card {
					border-radius: 4px;
					min-width: 250px;
					height: 330px;


					.card-image {
							img {
									border-top-left-radius: 4px;
									border-top-right-radius: 4px;
									height: 150px;
							}
					}

					.score-badge {
						width: 100%;
						background-color: #7A8189;
						color: white;
						padding: 5px;
					

						div {
							text-align: center;
							width: 50%;
							font-weight: 600;
							font-size: 12px;

							&:first-child {
								border-right: 1px solid #F2F3F4;
							}
						}
					}

					.score-badge.completed {
						background-color: #1DC05E;
					}

					.score-badge.uncompleted {
						background-color: #E8313B;
					}
			}

        // .carousel-slides {

        //     .carousel-slide {
        //         border-radius: 4px;
        //         margin-right: 1rem;
				// 				max-width: 250px;
				// 				height: 330px;

        //         .card {
        //             border-radius: 4px;

        //             .card-image {
        //                 img {
        //                     border-top-left-radius: 4px;
        //                     border-top-right-radius: 4px;
				// 										height: 150px;
        //                 }
        //             }

				// 						.score-badge {
				// 							width: 100%;
				// 							background-color: #7A8189;
				// 							color: white;
				// 							padding: 5px;
										

				// 							div {
				// 								text-align: center;
				// 								width: 50%;
				// 								font-weight: 600;
				// 								font-size: 12px;

				// 								&:first-child {
				// 									border-right: 1px solid #F2F3F4;
				// 								}
				// 							}
				// 						}

				// 						.score-badge.completed {
				// 							background-color: #1DC05E;
				// 						}

				// 						.score-badge.uncompleted {
				// 							background-color: #E8313B;
				// 						}
        //         }
        //     }
        // }

        .carousel-arrow {
					.icon {
						background: #142246;
						color: white;
						width: 32px;
						height: 32px;
						border: none;

						&.has-icons-right {
							right: .5rem
						}
						&.has-icons-left {
							left: .5rem
						}

						&:hover {
							border: 1px solid #142246;
						}
					}
					
        }

        .carousel-list.has-shadow {
            box-shadow: none;
        }

        .card {

            .card-content {
                padding: .8rem;

                .title {
                    font-size: 14px;
                    font-weight: 500;
                    padding-bottom: .8rem;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
                }

                .subtitle {
                    color: #7A8189;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
                }
            }

						.card-action {
							width: 100%;
							padding: .8rem;
							position: absolute;
							bottom: 0;
							
							button {
								width: 100%;
								height: 40px;
								border-radius: 0;
								border: none;
								background: #ff8200;
								color: white;
								font-size: 14px;
								font-weight: 500;
							}

							button.redo {
								background: rgba(255, 130, 0, .1);
								color: #ff8200;
							}
						}
        }
        
  }

	.regular-courses {
		padding: 0 2rem 2rem 2rem;

		> div {
			margin-top: 2rem;
		}

		.title-category {
			font-size: 20px;
			font-weight: 600;
			color: #1A1A1A;
			margin-bottom: .5rem;
		}

		.desc-category {
			margin-bottom: 1rem;
			color: #7A8189;
		}

		.courses {
			width: 100%;

			.normal-courses {
				.course {
					.media {
						.media-content {
							p {
								strong {
									font-size: 14px;
									font-weight: 500;
								}

								span {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
			
			.btn-action {
				background-color: #F2F2F2;
				color: #142246;
				font-weight: 500;
				border: none;
				width: 200px;
				margin: 0 auto;
				outline: 0;
			}
		}
	}
}

@media screen and (min-width: 320px) and (max-width: 780px) {
	.online-training {
		.featured-courses {
			padding: 1rem;

			h3 {
					font-size: 24px;
					margin-bottom: 1rem;
        }
			#featured {
				max-width: 100%;
			}
			.carousel-slides {
				.carousel-slide {
					max-width: auto !important;

					.card {
						.card-image {
							img {
									height: auto;
							}
						}
					}
				}
			}
		}

		.regular-courses {
			padding: 0 1rem 1rem 1rem;

			> div {
				margin-top: 1rem;
			}
		}
	}
}
</style>
